import { graphql } from "gatsby"
import React from "react"

import CoreHeading from "@knowit-alma/common/src/components/atoms/CoreHeading/CoreHeading"

const CoreHeadingBlock = ({ text, level, align, textAlign, idAttribute }) => {
  return (
    <CoreHeading
      text={text}
      level={`h${level}`}
      align={textAlign ? textAlign : align}
      idAttribute={idAttribute}
    />
  )
}

export const query = graphql`
  fragment CoreHeading on WpBlockCoreHeading {
    __typename
    text
    level
    align
    textAlign
    idAttribute
  }
`

export default CoreHeadingBlock
